module.exports = __webpack_public_path__ + "static/reports-f05d05f0973e3f789a9eef638ee8b307.mp4";